import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const MAX_QUANTITY = 1_000_000;

export const addProductToStorageLocation = {
  name: "addProductToStorageLocation" as const,
  input: z.object({
    storageLocationId: storageLocationIdFormat.schema,
    productId: productIdFormat.schema,
    /** Units to place in the bin. Omitted or 0 assigns the product with no stock. */
    quantity: z.number().int().min(0).max(MAX_QUANTITY).nullish(),
    note: z.string().max(1000).nullish(),
  }),
  output: z.object({ quantity: z.number().int() }),
};
